module.exports = __webpack_public_path__ + "img/LOGO_NBP_SMALL.17d56a23.png";